//core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { documentsService } from "../../../services/common/documents.service";
import { setUser } from "../../common/user";
import {
  setCreateCreativeState,
  setGeneralProgressHide,
  setGeneralProgressShow,
  setGeneralSnackbarState
} from "../../common/ui";

export type DocumentsSliceState = {
  faq: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
  cookie_policy: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
  terms_and_conditions: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
  privacy_policy: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
  essential_cookies: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
  analytical_cookies: {
    data: any | null,
    error: any,
    isFetching: boolean,
  },
};

const initialState: DocumentsSliceState = {
  faq: {
    data: null,
    error: null,
    isFetching: false,
  },
  cookie_policy: {
    data: null,
    error: null,
    isFetching: false,
  },
  terms_and_conditions: {
    data: null,
    error: null,
    isFetching: false,
  },
  privacy_policy: {
    data: null,
    error: null,
    isFetching: false,
  },
  essential_cookies: {
    data: null,
    error: null,
    isFetching: false,
  },
  analytical_cookies: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getDocumentData: any = createAsyncThunk(
  'document/getDocumentData',
  async (payload:any, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await documentsService.getDocument(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setGeneralProgressHide());
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());
      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

//slice
const documentsSlice = createSlice({
  name: 'documents',
  initialState: initialState,
  reducers: {
    clearDocumentState(state:any, action: any) {
      const type = action.payload;
      if (state[type]) {
        state[type].data = null;
        state[type].error = null;
        state[type].isFetching = false;
      }
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<DocumentsSliceState>>) => {
    builder.addCase(getDocumentData.pending, (state:any, action:any) => {
      const type = action.meta.arg.type;
      if (state[type]) {
        state[type].isFetching = true;
        state[type].error = null;
      }
    });
    builder.addCase(getDocumentData.fulfilled, (state:any, action:any) => {
      const type = action.meta.arg.type;
      if (state[type]) {
        state[type].error = null;
        state[type].isFetching = false;
        state[type].data = action.payload;
      }
    });
    builder.addCase(getDocumentData.rejected, (state:any, action:any) => {
      const type = action.meta.arg.type;
      if (state[type]) {
        state[type].isFetching = false;
        state[type].error = action.payload;
      }
    });
  },
});

export default documentsSlice.reducer;

export const {
  clearDocumentState,
} = documentsSlice.actions;
